$(function() {

	/**
	 * toggle mobile menu
	 */    
    $('body .mobile-menu-btn').on('click', function () {
        $('.mobile-menu').toggleClass('mobile-menu-visible');
    });

    /**
     * fixed header
     */
	var fixedHeader = false, fixedToolbar = false;
	var $body = $("body");
	var $toolbar = $(".toolbar");
	var toolbarBreakpoint = $toolbar.length ? ($toolbar.offset().top - 104) : 0;

	$(window).on("scroll", function(e) {
		var scrollTop = $(window).scrollTop();

		if(!fixedHeader && scrollTop >= 1) {
			fixedHeader = true;
			$body.addClass("scrolled");
		}
		else if(fixedHeader && scrollTop == 0) {
			window.setTimeout(function() {
				fixedHeader = false;
				$body.removeClass("scrolled");
			},100);
		}

		if($toolbar.length) {
			if(!fixedToolbar && scrollTop >= toolbarBreakpoint) {
				fixedToolbar = true;
				$toolbar.addClass("toolbar-fixed");
			}
			else if(fixedToolbar && scrollTop < toolbarBreakpoint) {
				window.setTimeout(function() {
					fixedToolbar = false;
					$toolbar.removeClass("toolbar-fixed");
				},100);
			}
		}
	});


	/**
	 * resize responsive iframes
	 */
	var $responsiveFrames = $(".iframe-responsive, .embed-responsive iframe");

	if($responsiveFrames.length)
	{
		$responsiveFrames.each(function() {
			$(this).data('aspectRatio', this.height / this.width)
			    .removeAttr('height')
		    	.removeAttr('width');
		});

		function resizeFrames() {
			  $responsiveFrames.each(function() {
					var $frame = $(this);
					var $container = $frame.closest(".iframe-responsive-container");
					if($container.length) {
						var parentWidth = $container.width();
				    	$frame.width(parentWidth)
				      		  .height(parentWidth * $frame.data('aspectRatio'));
					}
				});
		}

		resizeFrames();
		$(window).resize(resizeFrames);
	}


	/**
	 * play video
	 */
	var $video = null;
	var $videoUrl = null;
	var videoUrl = null;

	var isVideoPending = false;
	$(".featured-video").bind('touchstart click', function(){

		if(!isVideoPending) {
			$videoUrl = $(this);
			videoUrl = $videoUrl.attr("data-video-url");

			isVideoPending = true;
			setTimeout(function(){ 

				var $video_embed = null;

				if(videoUrl && videoUrl.indexOf("youtu") > 0) {
					var video_id = videoUrl.split('v=')[1];
					var ampersandPosition = video_id ? video_id.indexOf('&') : -1;
					if(ampersandPosition !== -1) {
						video_id = video_id.substring(0, ampersandPosition);
					}

					if(video_id)
					{
						$video_embed = $('<iframe />', {
							name: 'youtube',
							id: 'youtube',
							src : 'https://www.youtube.com/embed/' + video_id + "?autoplay=1",
							frameborder : '0',
							allowfullscreen : true,
							width : '100%',
							height : '100%',
							});
					}
				}
				else if(videoUrl && videoUrl.indexOf("vimeo") > 0 && 
						(video_id = videoUrl.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i))
						&& video_id.length >= 2 && video_id[1])
				{
					video_id = video_id[1];

					$video_embed = $('<iframe />', {
							name: 'vimeo',
							id: 'vimeo',
							src : 'https://player.vimeo.com/video/' + video_id + "?autoplay=1",
							frameborder : '0',
							allowfullscreen : true,
							width : '100%',
							height : '100%',
							});
				}
				else {
					if($videoUrl.children("div").first().children().length) {
						$video_embed = $videoUrl.children("div").first();
					}
				}

				if($video_embed) {
					var width = Math.min($("header").width(), 1024, $(window).width()-40);
					var height = Math.round(width * 9 / 16,0);

					$video_embed.appendTo('.video-container');
					$(".video-container").width(width).height(height);
					$(".video-overlay").show();

					if(!$video)
					{
						$video = $(".video-container");
						$(window).resize(function() {
							if($video)
							{
								var width =  Math.min($("header").width(), 1024, $(window).width()-40);
								var height = Math.round(width * 9 / 16,0);	
								
								$video.width(width).height(height);
							}
						});

						$(".video-overlay").click(function() {
							$video.find("iframe").remove();
							$(this).hide();
						});
					}
				}
/*

*/

				isVideoPending = false;
				return false;
			}, 100);
		}
		return false;
	});

	function resizeContactHeight() {
		$('.group__contacts').each(function(idx) {
			var ic = '.icon-' + (idx+1);
			$('.icon-' + (idx+1)).css('height' , $('.contacts-' + (idx+1)).innerHeight() + 'px');
		});

	}
	resizeContactHeight();
	$(window).resize(resizeContactHeight);
});